<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Test Task Form Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading :title="`Update ${test_process.name} ${test_task.name}`">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'edit test task'">
      <template #gated-content>
        <test-task-form
          :test_process="test_process"
          :test_task="test_task"
          @submit="submit"
        />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import TestTaskForm from "@/components/lab/testtask/TestTaskForm";
import { getModel } from "@/shared/fetch-utils";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { notificationOptions } from "@/shared/toast-notification-options";
import { testTaskNotifications } from "@/shared/notifications";

const TestTaskRepository = LabRepositoryFactory.get("testTask");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "TestTaskEdit",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    TestTaskForm,
  },
  data() {
    return {
      loading: true,
      test_task_id: this.$route.params.test_task_id || null,
      test_task: null,
      test_process: null,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: `/test-processes/${this.test_process.id}`,
            title: "Test task list",
          },
          {
            icon: "fa-eye",
            linkto: `/test-tasks/${this.test_task_id}`,
            title: "View test tasks",
            variant: "info",
          },
        ],
      };
    },
  },
  methods: {
    async init() {
      this.test_task = await getModel({
        model_type: "test_task",
        id: this.test_task_id,
        message: this.$bvToast,
      });
      this.test_process = await getModel({
        model_type: "test_process",
        id: this.test_task.test_process_id,
        message: this.$bvToast,
      });

      this.loading = false;
    },
    async submit(form_data) {
      const { name, description, relations } = form_data;
      const payload = {
        name,
        description,
        relations,
        test_process_id: this.test_process.id,
      };
      try {
        const { data } = await TestTaskRepository.update(
          this.test_task_id,
          payload
        );

        this.editSuccess();

        this.$router.push(`/test-tasks/${data.id}`);
      } catch ({ response }) {
        this.$bvToast.toast(response.data.error, {
          title: "Task update Failed.",
          variant: "danger",
        });
      }
    },
  },
  created() {
    this.loading = true;

    this.init();
  },
  notifications: testTaskNotifications,
};
</script>
